import React from 'react';
import { ConfigProvider, Layout } from 'antd';
import FengShuiAnalyzer from './pages/FengShuiAnalyzer';
import 'antd/dist/reset.css';
import './App.css';

const { Header, Content, Footer } = Layout;

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#8f3f2a',
          colorSuccess: '#3f7b58',
          colorWarning: '#b67a24',
          colorError: '#b94a3a',
          colorInfo: '#58736d',
          borderRadius: 6,
          fontFamily:
            '"Noto Serif SC", "Songti SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, sans-serif',
        },
        components: {
          Button: {
            controlHeightLG: 48,
            borderRadius: 4,
          },
          Card: {
            borderRadiusLG: 8,
            boxShadowTertiary: 'none',
          },
          Tabs: {
            itemSelectedColor: '#8f3f2a',
            inkBarColor: '#8f3f2a',
          },
        },
      }}
    >
      <Layout className="layout">
        <Header className="site-header">
          <div className="header-inner">
            <a className="brand-mark" href="#main-content" aria-label="返回分析区">
              <span className="brand-symbol">坤</span>
              <span>
                <strong>宅衡</strong>
                <small>AI 阳宅风水分析</small>
              </span>
            </a>
            <nav className="top-nav" aria-label="主导航">
              <a href="#upload">户型上传</a>
              <a href="#method">分析依据</a>
              <a href="#result">结果解读</a>
            </nav>
          </div>
        </Header>
        <Content id="main-content" className="site-content">
          <FengShuiAnalyzer />
        </Content>
        <Footer className="site-footer">
          <span>AI Feng Shui Prediction System ©{new Date().getFullYear()}</span>
          <span>
            仅供居住规划参考 · <a href="/privacy/">隐私政策</a>
          </span>
        </Footer>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
